import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsBlackEpic({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g id="Group"><g id="Group_2"><path vectorEffect="non-scaling-stroke" id="Path" d="M12.1901 22.0601L20.8101 7.14006" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_2" d="M3.19006 7.14006L11.8101 22.0601" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_3" d="M3.39011 6.80005L20.6101 6.80005" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_4" fillRule="evenodd" clipRule="evenodd" d="M3 16.041L3 7.95804C3 7.24304 3.381 6.58304 4 6.22604L11 2.18504C11.619 1.82804 12.381 1.82804 13 2.18504L20 6.22604C20.619 6.58304 21 7.24404 21 7.95804L21 16.041C21 16.756 20.619 17.416 20 17.773L13 21.814C12.381 22.171 11.619 22.171 11 21.814L4 17.773C3.381 17.416 3 16.756 3 16.041Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g></g></Svg>;
}
export default OrdinalsBlackEpic;